<template>
  <div>
    <div class="mainContent">
      <a-form-model :layout="layout" style="width:100%;" ref="ruleForm" :model="form">
        <a-col :sm="24" :md="12" :lg="8" :xl="6">
          <a-form-model-item label="用户名" colon :labelCol='labelcol' :wrapperCol="wrappercol" prop="username">
              <a-input v-model="form.username" placeholder="请输入用户名..." />
            </a-form-model-item>
          </a-col>
          <a-col :sm="24" :md="12" :lg="8" :xl="6">
            <a-form-model-item label="角色" :labelCol='labelcol' :wrapperCol="wrappercol" prop="role">
              <a-select v-model="form.role" placeholder="请选择用户角色..." :options='role'>

              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :sm="24" :md="12" :lg="8" :xl="6">
            <a-form-model-item label="状态" :labelCol='labelcol' :wrapperCol="wrappercol" prop="is_delete">
              <a-select v-model="form.is_delete" placeholder="请选择用户状态..." :options='is_delete'>
              </a-select>
            </a-form-model-item>
          </a-col>

          <a-col :sm="24" :md="12" :lg="8" :xl="6" class="lyq_flex_grow">
            <a-form-model-item style="text-align:right;">

              <a-button type="primary" @click="search">
                搜索
              </a-button>
              <a-button @click="reset('ruleForm')">重置</a-button>

            </a-form-model-item>
          </a-col>
      </a-form-model>
    </div>
    <div class="mainContent" style="display: flex;justify-content: flex-end;">
      <a-button type="primary" @click="onAddUser">
        添加用户
      </a-button>
    </div>
    <div class="mainContent" >

      <div class="tableHeader">
        <div class="title">查询表格</div>
        <div class="operate">

          <a-tooltip placement="top">
            <template slot="title">
              <span>下载</span>
            </template>
            <a class="ant-dropdown-link" style="display:block;margin-right:10px;" @click="start" :disabled="!selectedRowKeys.length > 0">
              <a-icon type="vertical-align-bottom" />
            </a>
          </a-tooltip>

          <a-tooltip placement="top">
            <template slot="title">
              <span>表格大小</span>
            </template>
            <a-dropdown :trigger="['click']" style="margin-right:10px;">
              <a class="ant-dropdown-link" style="display:block">
                <a-icon type="column-height" />
              </a>
              <a-menu slot="overlay">
                <a-menu-item>
                  <a @click="tableSize='default'">默认</a>
                </a-menu-item>
                <a-menu-item>
                  <a @click="tableSize='middle'">中等</a>
                </a-menu-item>
                <a-menu-item>
                  <a @click="tableSize='small'">紧凑</a>
                </a-menu-item>
              </a-menu>
            </a-dropdown>
          </a-tooltip>

        </div>
      </div>

      <a-table
        :size="tableSize"
        :scroll="{ x: true }"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :columns="columns"
        :row-key="record => record.id"
        :data-source="data"
        :pagination="pagination"
        :loading="loading"
        bordered
        @change="handleTableChange"
      >
      <!-- 角色单元格 -->
      <template slot="role" slot-scope="data,record">
            {{record.role|roleFilter}}
      </template>
        <!-- 状态单元格 -->
        <template slot="is_delete" slot-scope="data,record">
          <a-tag :color="record.is_delete=='0'?'green':'red'">
              {{record.is_delete|statusFilter}}
          </a-tag>
        </template>
        <!-- 组ID -->
        <template slot="es_host_ids" slot-scope="data,record">
          {{es_host_name(record.es_host_ids)}}
        </template>
        <!-- 操作单元格 -->
        <template slot="操作" slot-scope="data">

              <span>

                <a-button size="small" type="primary"  @click="onEditUser(data)">编辑</a-button>

                <a-popconfirm v-if="data.is_delete=='0'" title="是否禁用此账号?" @confirm="() => onDisableUser(data)">
                  <a-button size="small" type="danger">禁用</a-button type="primary" >
                </a-popconfirm>
                <a-popconfirm v-else title="是否启用此账号?" @confirm="() => onEnableUser(data)">
                  <a-button size="small" type="primary" class="greenBtn">启用</a-button type="primary">
                </a-popconfirm>

                <a-button size="small" type="primary"  @click="onChangePassword(data)">修改密码</a-button>

              </span>

        </template>
      </a-table>
    </div>

  <!-- 修改帐号信息模态框 -->
  <a-modal

      title="编辑"
      :visible="editModalVisible"
      :confirm-loading="confirmLoading"
      @ok="saveUser"
      @cancel="cancelUser"
    >
      <!-- 编辑 -->
      <a-form-model
        ref="editUser"
        :model="editUserForm"
        :rules="editUserFormRules"
        :label-col="{span:7}"
        :wrapper-col="{span:17}"
      >
        <a-form-model-item label="用户名" prop="username">
          <a-input v-model="editUserForm.username" disabled/>
        </a-form-model-item>
        <a-form-model-item label="角色" prop="role">
          <a-select v-model="editUserForm.role" placeholder="请选择用户角色..." :options='role'>

          </a-select>
        </a-form-model-item>
        <a-form-model-item label="组ID" prop="es_host_ids">
          <a-select v-model="editUserForm.es_host_ids" mode="multiple" placeholder="请选择组ID..." :options='es_hosts_data'>

          </a-select>
        </a-form-model-item>
        <a-form-model-item label="状态" prop="is_delete">
          <a-select v-model="editUserForm.is_delete" placeholder="请选择用户状态..." :options='is_delete_edit'>

          </a-select>
        </a-form-model-item>

      </a-form-model>
  </a-modal>
  <!-- 修改密码模态框 -->
  <a-modal

    title="修改密码"
    :visible="changePasswordModalVisible"
    :confirm-loading="changePasswordConfirmLoading"
    @ok="savePassword"
    @cancel="cancelChangePassword"
  >

    <a-form-model
      ref="changePassword"
      :model="changePasswordForm"
      :rules="changePasswordFormRules"
      :label-col="{span:7}"
      :wrapper-col="{span:17}"
    >
      <a-form-model-item label="新密码" prop="password">
        <a-input v-model="changePasswordForm.password" />
      </a-form-model-item>
      <a-form-model-item label="确认密码" prop="password1">
        <a-input v-model="changePasswordForm.password1" />
      </a-form-model-item>

    </a-form-model>
  </a-modal>
  <!-- 添加帐号信息模态框 -->
  <a-modal

      title="添加"
      :visible="addModalVisible"
      :confirm-loading="addConfirmLoading"
      @ok="add_saveUser"
      @cancel="add_cancelUser"
    >
      <!-- 添加 -->
      <a-form-model
        ref="addUser"
        :model="addUserForm"
        :rules="addUserFormRules"
        :label-col="{span:7}"
        :wrapper-col="{span:17}"
      >

        <a-form-model-item label="用户名" prop="username">
          <a-input v-model="addUserForm.username" />
        </a-form-model-item>
        <a-form-model-item label="密码" prop="password">
          <a-input v-model="addUserForm.password" />
        </a-form-model-item>
        <a-form-model-item label="确认密码" prop="password1">
          <a-input v-model="addUserForm.password1" />
        </a-form-model-item>
        <a-form-model-item label="组ID" prop="es_host_ids">
          <a-select v-model="addUserForm.es_host_ids" mode="multiple" placeholder="请选择组ID..." :options='es_hosts_data'>

          </a-select>
        </a-form-model-item>
        <a-form-model-item label="状态" prop="is_delete">
          <a-select v-model="addUserForm.is_delete" placeholder="请选择用户角色..." :options='is_delete'>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="角色" prop="role">
          <a-select v-model="addUserForm.role" placeholder="请选择用户角色..." :options='role'>
          </a-select>
        </a-form-model-item>
      </a-form-model>
  </a-modal>
  </div>
</template>
<script>
import {getUserList,editUser,addUser,deleteUser,changePassword} from "@/axios/user.js"
import {getAllESHostsList} from "@/axios/es_host.js"
import {myMixin} from "@/static/js/mixin.js"
import moment from 'moment';
const columns = [//列描述
  {
    align:'center',
    title: '用户名',
    dataIndex: 'username',
  },

  {
    align:'center',
    title: '角色',
    dataIndex: 'role',
    scopedSlots: { customRender: 'role', },
  },
  {
    align:'center',
    title: '状态',
    dataIndex: 'is_delete',
    scopedSlots: { customRender: 'is_delete', },
  },
  {
    align:'center',
    title: 'es_host组',
    dataIndex: 'es_host_ids',
    scopedSlots: { customRender: 'es_host_ids', },
  },
  {
    align:'center',
    title: '操作',
    // dataIndex: 'status',
    scopedSlots: { customRender: '操作', },
  },

];
export default {
  filters: {

    statusFilter(status) {
      const statusMap = {
        "0": '启用',
        "1": '禁用',
      }

      return statusMap[status]

    },
    roleFilter(status) {
      const statusMap = {
        super: '管理员',
        normal: '普通用户',
      }

      return statusMap[status]

    }

  },
  mixins: [myMixin],
  data() {
    let validatePass2 = (rule, value, callback) => {
      if (value !== this.addUserForm.password) {
        callback(new Error("两次密码不一致!"));
      } else {
        callback();
      }
    };
    let validatePass3 = (rule, value, callback) => {
      if (value !== this.changePasswordForm.password) {
        callback(new Error("两次密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      is_delete_edit: [
        {
            value: 0,
            label: '启用'
        },
        {
            value: 1,
            label: '禁用'
        },
      ],
      is_delete: [
        {
            value: -1,
            label: '全部'
        },
        {
            value: 0,
            label: '启用'
        },
        {
            value: 1,
            label: '禁用'
        },
      ],
      role: [
        {
            value: '',
            label: '全部'
        },
        {
            value: 'super',
            label: '管理员'
        },
        {
            value: 'normal',
            label: '普通用户'
        },
      ],
      form: {
        page_size: 10,
        page:1,
        username: '',
        role: '',
        is_delete: -1,
      },
      columns,//列描述


      confirmLoading:false,//编辑模态框
      editModalVisible:false,
      editUserForm:{
        username:'',
        role:'',
        user_id:'',
        es_host_ids:[],
        is_delete:'',
      },
      editUserFormRules: {
        username: [
          { required: true, message: '请输入用户名', trigger: 'blur' },
        ],
        role: [
          { required: true, message: '请选择用户角色', trigger: 'change' },
        ],
        is_delete: [
          { required: true, message: '请选择用户状态', trigger: 'change' },
        ],
      },

      addConfirmLoading:false,//添加模态框
      addModalVisible:false,
      addUserForm:{
        username:'',
        password:'',
        es_host_ids:[],
        password1:'',
        role:'',
        is_delete:'',
      },
      addUserFormRules: {
        username: [
          { required: true, message: '请输入用户名', trigger: 'blur' },
        ],

        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { message: '密码长度为6-18', trigger: 'blur',min:6,max:18 },
        ],
        password1: [
          { validator:validatePass2, required: true,trigger: 'blur' },
        ],
        role: [
          { required: true, message: '请选择角色', trigger: 'change' },
        ],
        is_delete: [
          { required: true, message: '请选择状态', trigger: 'change' },
        ],
      },

      changePasswordConfirmLoading:false,//修改密码模态框
      changePasswordModalVisible:false,
      changePasswordForm:{
        user_id:'',
        password:'',
        password1:'',

      },
      changePasswordFormRules: {//修改密码表单验证规则
        password: [
          { required: true, message: '请选择角色', trigger: 'blur' },
          { message: '密码长度为6-18', trigger: 'blur',min:6,max:18 },
        ],
        password1: [
          { validator:validatePass3, required: true,trigger: 'blur' },
        ],

      },
      es_hosts_data:[],
    }

  },
  created(){
    let that=this
    
    
    getAllESHostsList().then((data)=>{
      that.es_hosts_data=data.data.map((item)=>{
        return{
          value:item.es_hosts_id+'',
          label:item.es_hosts_name
        }
      })
      that.fetch();
    });
    
  },
  mounted() {
  },
  methods:{
      es_host_name(ids){
        let name=''
        if(ids&&ids.length>0){
          ids.map((item)=>{
            this.es_hosts_data.map((i)=>{
              if(i.value==item) name =name + i.label+ ','
            })
          })
        }
        return name
      },
      async fetch (params = {}) {
        this.loading = true;
        let data=await getUserList({...params,...this.form})
        this.loading = false;
        console.log(data,'data')
        const pagination = { ...this.pagination };
        pagination.total = data.data.total-0;

        this.data = data.data.list;
        this.pagination = pagination;
      },
      //禁用账号
      async onDisableUser(data){
        data.is_delete=1
        let resule=await editUser({...data,user_id:data.id});
          if(resule.status==1){
            this.$message.success(resule.errmsg);
            this.fetch()
          }else{
            this.$message.error(resule.errmsg);
        }
      },
      //启用账号
      async onEnableUser(data){
        data.is_delete=0
        let resule=await editUser({...data,user_id:data.id});
          if(resule.status==1){
            this.$message.success(resule.errmsg);
            this.fetch()
          }else{
            this.$message.error(resule.errmsg);
        }
      },

      //修改密码
      async onChangePassword(data){
        this.changePasswordForm.user_id=data.id
        this.changePasswordModalVisible=true
      },
      //保存密码
      async savePassword(data){
        this.$refs.changePassword.validate( async valid => {
          if (valid) {
            this.changePasswordConfirmLoading = true;
            let resule=await changePassword(this.changePasswordForm);
            if(resule.status==1){
              console.log(resule)
              this.$message.success(resule.errmsg);
              this.changePasswordModalVisible = false;
              this.changePasswordConfirmLoading = false;
              this.$refs.changePassword.resetFields();
              this.fetch();
            }else{
              this.$message.error(resule.errmsg);
              this.changePasswordConfirmLoading = false;
            }

          } else {
            return false;
          }

        })
      },
      cancelChangePassword(){
        this.$refs.changePassword.resetFields();
        this.changePasswordModalVisible = false;
      },

      //添加用户数据
      onAddUser(){
        this.addModalVisible=true
      },
      add_saveUser(){
        this.$refs.addUser.validate( async valid => {
          if (valid) {
            this.addConfirmLoading = true;

            let resule=await addUser(this.addUserForm);
            if(resule.status==1){
              console.log(resule)
              this.$message.success(resule.errmsg);
              this.addModalVisible = false;

              this.$refs.addUser.resetFields();
              this.fetch();
            }else{
              this.$message.error(resule.errmsg);

            }
            this.addConfirmLoading = false;
          } else {
            return false;
          }
        });


      },
      add_cancelUser(){
        this.$refs.addUser.resetFields();
        this.addModalVisible = false;
      },

      //编辑保存用户数据
      onEditUser(data){
        this.editUserForm={...data}
        this.editUserForm.user_id=data.id
        console.log(this.editUserForm,'data')
        this.editModalVisible=true
      },
      saveUser(){
        this.$refs.editUser.validate( async valid => {
        if (valid) {
          this.confirmLoading = true;
          let resule=await editUser({...this.editUserForm});
          if(resule.status==1){
            console.log(resule)
            this.$message.success(resule.errmsg);
            this.editModalVisible = false;
            this.confirmLoading = false;
            this.$refs.editUser.resetFields();
            this.fetch();
          }else{
            this.$message.error(resule.errmsg);
            this.confirmLoading = false;
          }

        } else {
          return false;
        }
      });


      },
      cancelUser(){
        this.$refs.editUser.resetFields();
        this.editModalVisible = false;
      },
    }
};
</script>
<style lang="scss" scoped>
@import "@/static/css/index.scss";
.ant-table td { white-space: nowrap; }
.ant-table td .greenBtn{background-color:#7ac141;border-color:#7ac141;}
</style>
